/** Unicode Eastern Arabic-Indic digits (U+0660–U+0669), common for Arabic UI text */
const EASTERN_ARABIC_DIGITS = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];

/**
 * Replaces Western digits 0–9 with Eastern Arabic numerals (٠–٩) when `langValue === "ar"`.
 * Other languages return the value unchanged (still stringified when non-null).
 */
export function localizeWesternDigitsForLang(value, langValue) {
  if (value == null) return value;
  // Objects (e.g. {en, ar}) are not valid React children — callers must resolve lang first.
  if (typeof value === "object") return undefined;
  const str = String(value);
  if (langValue !== "ar") return str;
  return str.replace(/\d/g, (d) => EASTERN_ARABIC_DIGITS[Number(d)] ?? d);
}
